import { FETCH_DATA } from "./testPageConstants";
import { FETCH_CLOUD_DATA } from "./testPageConstants";
import {
    asyncActionStart,
    asyncActionFinish,
    asyncActionError
} from "../../features/async/asyncActions";
import { fetchSampleData } from "../../data/mockAPI";
import { fetchDataFromCloud } from "../../data/cloudService.js";
import firebase from "../../config/firebase";
import { toastr } from "react-redux-toastr";
import moment from "moment";
import cuid from "cuid";

export const fetchData = data => {
    return {
        type: FETCH_DATA,
        payload: data
    };
};

export const fetchCloudData = data => {
    return {
        type: FETCH_CLOUD_DATA,
        payload: data
    };
};

export const loadData = () => {
    return async dispatch => {
        try {
            dispatch(asyncActionStart());
            let data = await fetchSampleData();
            dispatch(fetchData(data));
            dispatch(asyncActionFinish());
        } catch (error) {
            console.log("error found", error);
            dispatch(asyncActionError());
        }
    };
};

export const loadDBData = (category, limit) => {
    return async dispatch => {
        try {
            dispatch(asyncActionStart());
            let data = await fetchDataFromCloud(category, limit);
            dispatch(fetchCloudData(data));
            dispatch(asyncActionFinish());
        } catch (error) {
            console.log("error found", error);
            dispatch(asyncActionError());
        }
    };
};

export const updateTestAttendee = (
    testSnapShot,
    testScore,
    avgScore,
    topScore
) => {
    console.log("updateTestAttendee called ", testSnapShot);
    return async (dispatch, getState) => {
        const firestore = firebase.firestore();
        const user = firebase.auth().currentUser;
        const photoURL = getState().firebase.profile.photoURL;
        console.log("Users uid", user.uid);

        // const collection = testSnapShot.data().category;
        const collection = testSnapShot.data().testCollection;
        const id = testSnapShot.data().testId;
        // const avgScore = testSnapShot.data().avgScore;
        let attendees = testSnapShot.data().attendees;

        // Updating the Attendees list Collection
        try {
            await firestore
                .collection(collection)
                .doc(id)
                .collection("attendees")
                .doc(user.uid)
                .set({
                    takenAt: moment(Date.now())
                        .toDate()
                        .toString(),
                    photoURL: photoURL || "/assets/user.png",
                    displayName: user.displayName,
                    testScore
                });
            // .update({
            //     avgScore,
            //     attendees: attendees,
            //     topScore
            // });
            toastr.success("Success", "Test has been updated");
        } catch (error) {
            console.log(error);
        }

        // Updating the Test with attendees in database
        const attendee = {
            takenAt: moment(Date.now())
                .toDate()
                .toString(),
            photoURL: photoURL || "/assets/user.png",
            displayName: user.displayName,
            testScore
        };
        attendees[user.uid] = attendee;

        try {
            await firestore
                .collection(collection)
                .doc(id)
                .update({
                    avgScore,
                    attendees,
                    topScore
                });
        } catch (error) {
            console.log("failed to update ");
        }

        // Updating User profile in database
        // try {
        //     let testDocSnapshot = await firebase
        //         .firestore()
        //         .collection(collection)
        //         .doc(id)
        //         .get();

        //     const newTestAttended = {
        //         takenAt: moment(Date.now())
        //             .toDate()
        //             .toString(),
        //         testScore: testDocSnapshot.data().topScore,
        //         subject: testDocSnapshot.data().subject,
        //         testCollection: collection,
        //         testId: id,
        //         avgScore: testDocSnapshot.data().avgScore,
        //         attendees: testDocSnapshot.data().attendees
        //     };

        //     let userRef = await firestore
        //         .collection("users")
        //         .doc(user.uid)
        //         .get();
        //     let testAttended = userRef.data().testAttended;
        //     testAttended[id] = newTestAttended;
        //     await firestore
        //         .collection("users")
        //         .doc(user.uid)
        //         .update({
        //             testAttended: testAttended
        //         });
        //     toastr.success("Success", "User collection updated");
        // } catch (error) {
        //     console.log(error);
        // }

        // Updating user sub-collection
        try {
            //generate id
            let docId = cuid();
            console.log("iddddddddd ", docId);
            await firestore
                .collection("users")
                .doc(user.uid)
                .collection("activity")
                .doc(docId)
                .set({
                    type: "test",
                    testId: testSnapShot.data().testId,
                    subject: testSnapShot.data().subject,
                    testCollection: testSnapShot.data().testCollection,
                    takenAt: moment(Date.now()).toDate(),
                    testScore,
                    avgScore,
                    topScore
                });
            toastr.success("Success", "User collection updated");
        } catch (error) {
            console.log(error);
            toastr.error("Opps!", "Something went wrong");
        }
    };
};
